import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function QuestionMark(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (

    <Svg 
      {...svgProps}
      viewBox="0 0 20 20" role='presentation'>

        
        <G fill="none" fill-rule="evenodd">
         
          <Path fill="#535B61" d="M9.96533333,0.780649275 C4.882,0.780649275 0.746666667,4.73682319 
          0.746666667,9.59850435 C0.746666667,14.4608232 4.882,18.4163594 9.96533333,18.4163594 C15.0486667,
          18.4163594 19.184,14.4608232 19.184,9.59850435 C19.184,4.73682319 15.0486667,0.780649275 9.96533333,
          0.780649275 M9.96533333,19.1305623 C4.47066667,19.1305623 0,14.8542725 0,9.59850435 C0,4.34209855 
          4.47066667,0.0664463768 9.96533333,0.0664463768 C15.46,0.0664463768 19.93,4.34209855 19.93,9.59850435 
          C19.93,14.8542725 15.46,19.1305623 9.96533333,19.1305623" mask="url(#costquestionmark-b)"/>
          <Path fill="#535B61" d="M8.91030465,12.9080567 L8.91030465,13.2848967 C8.91030465,13.5116287 9.11812294,
          13.6956522 9.37516136,13.6956522 L9.79079794,13.6956522 C10.0478364,13.6956522 10.2556546,13.5116287 
          10.2556546,13.2848967 L10.2556546,12.9080567 C10.2556546,12.6813247 10.0478364,12.4973012 9.79079794,
          12.4973012 L9.37516136,12.4973012 C9.11812294,12.4973012 8.91030465,12.6813247 8.91030465,12.9080567 Z M7.82062584,
          7.10660616 C8.03391303,7.10723422 8.21575404,6.97659638 8.26770861,6.79382902 C8.35110937,6.49424129 8.55892767,
          6.26562507 8.90688658,6.12870656 C9.12769352,6.03889305 9.36559078,5.98676353 9.60827332,5.97545833 C10.3260668,
          5.95410407 10.9604595,6.16701862 11.1170068,6.92949139 C11.2181815,7.42566396 11.1409332,7.90801906 10.7628953,8.30998164 
          C10.3164962,8.785428 9.86052645,9.25584984 9.38951722,9.71245421 C9.04429276,10.0472137 8.96157561,10.4315904 8.94243445,
          10.8291565 C8.93081303,11.0665657 9.13863132,11.2669189 9.40729116,11.2669189 C9.40729116,11.2669189 9.80857187,11.2763399 
          9.91589908,11.2713153 C10.1387569,11.2593821 10.2324118,11.1972035 10.2289937,11.041443 C10.2173723,10.5804422 10.3889591,
          10.1960654 10.7868218,9.88077604 C11.0171993,9.69047188 11.233221,9.48823446 11.4335195,9.27280764 C11.9373421,8.75528081 
          12.3810069,8.20823486 12.4418484,7.49349514 C12.506108,6.7473521 12.3379393,6.06904024 11.672784,5.55088535 C11.2557802,
          5.22554688 10.7492231,5.07732318 10.2064345,5.02644979 C9.42985038,4.95422214 8.67514184,5.0151446 7.99699794,5.39512485 
          C7.4555766,5.69910905 7.12334077,6.10484003 7.00849382,6.61922653 C6.95243757,6.87108121 7.18144786,7.10660616 7.47129969,
          7.10660616 L7.82062584,7.10660616 Z"/>
        </G>
    </Svg>

  );
}

QuestionMark.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

QuestionMark.defaultProps = {
  height: 20,
  width: 20,
};

export default pure(QuestionMark);